<template>
<footer>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-md-10 col-sm-12">
        <div class="flexx">
          <div class="sitemap">
            <ul>
              <li><a href="#">Home</a></li>
              <li><a href="#">Projects</a></li>
              <li><a href="#">Contact Me</a></li>
            </ul>
          </div>
          <div class="social">
            <div class="wrapper">
              <a href="https://twitter.com/TheL0w3R" class="twitter"><i class="fab fa-twitter fa-fw"></i></a>
              <a href="https://www.instagram.com/lorenzorguez9/" class="instagram"><i class="fab fa-instagram fa-fw"></i></a>
              <a href="https://www.facebook.com/lorenzo.rodriguez.97" class="facebook"><i class="fab fa-facebook fa-fw"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="copyright">
    <p>© 2018 <span>Lorenzo Pinna Rodríguez</span></p>
  </div>
</footer>
</template>

<script>
export default {
  name: 'TFooter',
};
</script>

<style lang="scss">
footer {
  background: $dark_bg;
  .container {
    .flexx {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .sitemap {
        ul {
          list-style: none;
          margin: 0;
          padding: 30px 0;
          li {
            a {
              color: $text_gray;
              line-height: 1.4;
            }
          }
        }
      }
      .social {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .wrapper {
          a {
            display: inline-block;
            color: #fff;
            font-size: 40px;
            padding: 10px;
            border-radius: 2px;
            box-shadow: 0 3px 6px rgba(#000, .35);
            margin: 0 10px;
            &:last-child {
              margin-right: 0;
            }
            &:hover {
              i {
                transform: translateY(0);
              }
            }
            &.twitter {
              background: #55acee;
            }
            &.facebook {
              background: #3b5998;
            }
            &.instagram {
              background: #e4405f;
            }
            i {
              transform: translateY(5px);
              transition: all .2s ease;
            }
          }
        }
      }
    }
  }
  .copyright {
    background: #1E1E1E;
    padding: 15px;
    p {
      color: #7A7A7A;
      text-align: center;
      margin: 0;
      span {
        color: #AFADAD;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .social {
    .wrapper {
      a {
        font-size: 35px !important;
        i {
          transform: translateY(0) !important;
        }
        &:hover {
          i {
            transform: translateY(0) !important;
            text-shadow: 0 3px 6px rgba(#000, .35);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .social {
    .wrapper {
      a {
        font-size: 30px !important;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .social {
    .wrapper {
      a {
        font-size: 20px !important;
        margin: 0 5px !important;
        &:last-child {
          margin-right: 0 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/TFooter.vue